import $ from "jquery";
import "jszip";
import "pdfmake";
import DataTable, * as DT from "datatables.net";
import "datatables.net-buttons";
import "datatables.net-colreorder";
import "datatables.net-editor";
import "datatables.net-fixedcolumns";
import "datatables.net-fixedheader";
import "datatables.net-responsive";
import "datatables.net-rowgroup";
import "datatables.net-rowreorder";
import "datatables.net-searchpanes";
import "datatables.net-select";
import "datatables.net-staterestore";
import { InCoreSwal2, InCoreSwal2Icon } from "./swal.utils";
import { InCoreDateTimePickers } from "./flatpickr.utils";

//// Extend DataTables types to include 'ext'
declare global {
    namespace DataTables {
        interface Api {
            isDataTable: (table: string | HTMLElement | JQuery) => boolean;
        }
    }
}

// CLASSE PER LA CREAZIONE DELLE AZIONI DI RIGA
type HRefAction = {
    label: string;
    classes: string;
    href: string;
    target: string;
    permissionType: string;
    permissionValue: string;
};

type OnClickAction = {
    label: string;
    classes: string;
    click: string;
    permissionType: string;
    permissionValue: string;
};

type Action = HRefAction | OnClickAction;

export class InCoreDTActions {
    private actions: Action[];

    constructor() {
        this.actions = [];
    }

    /**
     * AGGIUNTA DI UNA AZIONE DI RIGA DI TIPO LINK
     * @param label TESTO DA MOSTRARE SUI PULSANTI (COMPATIBILE CON LE ICONE DI FONTAWESOME)
     * @param classes CLASSI CSS DA ASSEGNARE AL PULSANTE
     * @param href INDIRIZZO DEL COLLEGAMENTO DEL PULSANTE
     * @param target INDICA SE APRIRE IN QUESTA FINESTRA (DEFAULT: _self) O IN UNA NUOVA TAB
     * @param permissionType TIPO DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @param permissionValue VALORE DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @returns L'OGGETTO InCoreDTActions PER POTER CHIAMARE UNA NUOVA EVENTUALE .Add* IN CASCATA
     */
    public AddHRef(label: string, classes: string, href: string, target: string = "_self", permissionType: string, permissionValue: string): this {
        const action: HRefAction = { label, classes, href, target, permissionType, permissionValue };
        this.actions.push(action);
        return this;
    }

    /**
     * AGGIUNTA DI UNA AZIONE DI RIGA DI TIPO ON CLICK
     * @param label TESTO DA MOSTRARE SUI PULSANTI (COMPATIBILE CON LE ICONE DI FONTAWESOME)
     * @param classes CLASSI CSS DA ASSEGNARE AL PULSANTE
     * @param click FUNZIONE (COME TESTO) DA ESEGUIRE AL CLICK SUL PULSANTE
     * @param permissionType TIPO DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @param permissionValue VALORE DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @returns L'OGGETTO InCoreDTActions PER POTER CHIAMARE UNA NUOVA EVENTUALE .Add* IN CASCATA
     */
    public AddOnClick(label: string, classes: string, click: string, permissionType: string, permissionValue: string): this {
        const action: OnClickAction = { label, classes, click, permissionType, permissionValue };
        this.actions.push(action);
        return this;
    }

    public getActions(): Action[] {
        return this.actions;
    }
}

interface InCoreFilterConfig {
    ColumnName: string;
    Type: string;
    Label?: string;
    Url?: string;
    Values?: Array<{ Key: any; Value: string }> | null;
    Placeholder?: string;
}

interface InCoreDTConfig {
    filters?: InCoreFilterConfig[];
}

declare function InCoreSelect2(id: string): void;

export function InCoreDTRenderFilters(
    id: string,
    cfg: InCoreDTConfig,
    table: DataTables.Api
): void {

    const filterContainerId = `filters-${id}`;
    let $container = $(`#${filterContainerId}`);

    if (!$container.length) {
        const $tableEl = $(`#${id}`);
        $container = $(
            `<div id="${filterContainerId}" class="incore-dt-filters incore-row incore-row-6-column"></div>`
        );
        $tableEl.before($container);
    }

    (cfg.filters ?? []).forEach(f => {
        const filterId = f.ColumnName;

        let isSelect2 = false;
        let isDTP = false;
        let $input: JQuery<HTMLElement>;

        switch (f.Type.toLowerCase()) {
            case 'text':
                $input = $('<input type="text" class="form-control" />')
                    .attr('id', filterId);

                break;

            case 'date':
                $input = $('<input type="date" class="form-control" />')
                    .attr('id', filterId);

                isDTP = true;

                break;

            case 'select':
                $input = $('<select class="form-select"></select>')
                    .attr('id', filterId)
                    .attr('data-placeholder', f.Placeholder ?? '')
                    .attr('data-allowclear', 'true')
                    .attr('data-nosearch', 'false')
                    .attr('data-pagination', '50');

                if (f.Values) {
                    const $nullOption = $('<option></option>');
                    $input.append($nullOption);

                    f.Values?.forEach(({ Key, Value }) => {
                        const $option = $('<option></option>')
                            .attr('value', Key)
                            .text(Value);
                        $input.append($option);
                    });
                }

                isSelect2 = true;

                break;

            case 'select2':
                $input = $('<select class="form-select form-select-sm"></select>')
                    .attr('id', filterId)
                    .attr('data-placeholder', f.Placeholder ?? '')
                    .attr('data-allowclear', 'true')
                    .attr('data-nosearch', 'false')
                    .attr('data-pagination', '50')
                    .attr('data-ajax', f.Url ?? '');

                isSelect2 = true;

                break;

            default:
                return;
        }

        const $span = $(`<span class="text-danger" style="display: none;"></div>`);

        let cls = '';
        if (f.Label ?? '' == '') {
            cls = " m-0";
        }

        const $label = $(`<label class="control-label${cls}"></label>`)
            .text(f.Label ?? '')
            .attr('for', filterId);

        var classForm = "";
        if (isSelect2) {
            classForm = "w-100 incore-flex";
        }
        else {
            classForm = "form-floating";
        }
        const $form = $(`<div class="${classForm}"></div>`);

        if (isSelect2) {
            $form.append($label).append($input).append($span);
        }
        else {
            $form.append($input).append($label).append($span);
        }

        $container.append($form);

        if (isSelect2) {
            InCoreSelect2(filterId);
        }

        if (isDTP) {
            InCoreDateTimePickers(filterId);
        }

        $input.on('change', function () {
            const val = $(this).val() as any | null;

            console.log(val);

            const colIdx = table.columns().indexes().toArray()
                .find(i => table.column(i).dataSrc() === f.ColumnName);

            if (colIdx !== undefined) {
                console.log(table.column(colIdx));
                table.column(colIdx).search(val ?? "").draw();
            }
        });

    });
}

/**
 * Initializes a DataTable with custom configuration.
 * @param {string} id - ID of the HTML table.
 * @param {any} delta - Configuration overrides.
 * @param {any} actions - Optional row actions.
 * @param {string} refreshName - Optional refresh button method name.
 * @returns {DataTables.Api} - DataTable instance.
 */
export function InCoreDTCustom(id: string, delta: any, actions: any = undefined, refreshName: string | undefined = undefined): DataTables.Api {

    const defaultConfig = {
        //dom: '<"dt-otherButtons-container">f<"dt-buttons-container">B<"dt-filters-block">t<"dt-bottom"lip>',
        layout: {
            top9Start: {
                div: {
                    className: 'dt-title-container'
                }
            },
            top9: null,
            top9End: {
                div: {
                    className: 'dt-otherButtons-container'
                }
            },
            topStart:
            {
                search: {
                    placeholder: 'Cerca',
                },
            },
            top: null,
            topEnd: [
                {
                    div: {
                        className: 'dt-buttons-container'
                    }
                },
                { buttons: ['copy', 'csv', 'excel', 'pdf', 'print'] },
            ],
            bottomStart: null,
            bottom: [
                {
                    pageLength: {
                        menu: [[10, 25, 50, -1], [10, 25, 50, "All"]]
                    }
                },
                'info',
                {
                    paging: {
                        type: 'full_numbers'
                    }
                }
            ],
            bottomEnd: null,
        },
        lengthChange: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        responsive: true,
        language: {
            url: "/lib/datatables/i18n/it-IT.json",
            paginate: {
                first: '<i class="fa-solid fa-angles-left"></i>',
                previous: '<i class="fa-solid fa-chevron-left"></i>',
                next: '<i class="fa-solid fa-chevron-right"></i>',
                last: '<i class="fa-solid fa-angles-right"></i>',
            },
        },
    };

    const config = { ...defaultConfig, ...delta };

    config['initComplete'] = function (): void {
        const wrapperSelector = `#${id}_wrapper`;
        const buttonsContainer = `${wrapperSelector} .dt-buttons-container`;

        // Move buttons into container
        $(`${wrapperSelector}:not(.dt-buttons-container) > .dt-buttons`).appendTo(buttonsContainer);

  
        // Add refresh button if defined
        if (refreshName) {

            const fnRefresh = (window as any)[refreshName];
            const refreshButton = $(`
               <button class="btn btn-empty" style="padding: 0 4px; margin: 5px 1rem 0; color: rgba(55, 116, 255, 1); border-radius: 0;">
                   <i class="incore-mi-normal">refresh</i>
               </button>
    `       );
            refreshButton.on('click', () => {
                if (typeof (fnRefresh) === 'function') {
                    fnRefresh();
                }
            });
            refreshButton.prependTo(buttonsContainer);
        }

        // Move and show other buttons
        $(`.dt-otherButtons[data-dt='${id}']`).appendTo(`${wrapperSelector} .dt-otherButtons-container`).show();

        // Move and show other buttons
        $(`.dt-title[data-dt='${id}']`).appendTo(`${wrapperSelector} .dt-title-container`).show();

        // Remove sorting class and events
        $('.dt-nosorting').removeClass('sorting').off();

        // Replace label with styled input
        const label = $(`#${id}_filter.dataTables_filter > label`);
        if (label.length) {
            const input = label.find('input[type="search"]').clone(true);
            input.addClass('searchDT').attr('placeholder', 'Cerca');
            label.replaceWith(input);
        }

        // Prevent click propagation on last column if actions are enabled
        if (actions) {
            $(`#${id} tbody`).on('click', 'td:last-child', (e: JQuery.ClickEvent) => {
                e.stopPropagation();
            });
        }

        // Handle double-click and single-click row actions
        $(`#${id} tbody`).on('dblclick', 'tr', function () {
            const link = $(this).find('.dt-doubleclick');
            if (link.length > 0) {
                (link[0] as HTMLElement).click();
            }
        });

        $(`#${id} tbody`).on('click', 'tr', function () {
            const link = $(this).find('.dt-singleclick');
            if (link.length > 0) {
                (link[0] as HTMLElement).click();
            }
        });

        $(`#${id} tbody`).on('click dblclick', '.dt-azioni, .dt-azioni *', function (e) {
            e.stopPropagation();
        });

    };

    //if (delta.ajax != undefined) {
    //    config['ajax'] = function (): void {

    //    }
    //}

    //config['drawCallback'] = function (): void {

    //}

    if (actions) {
        config.columnDefs = DTManageActions(actions, delta);
    }

    return $(`#${id}`).DataTable(config);
}

/**
 * Initializes a DataTable using configurations fetched from the server.
 * @param {string} id - ID of the HTML table.
 * @param {string} dTName - Name of the DataTable on the server model.
 * @param {string} ajaxUrl - URL for the AJAX call to populate the table.
 * @param {any} actions - Array of actions to add to each row.
 * @param {string} controller - Absolute path for DataTables in other views.
 * @param {any} delta - Configuration overrides.
 * @param {string | undefined} refreshName - Optional refresh button method name.
 * @returns {Promise<DataTables.Api | null>} - DataTable instance or null on failure.
 */
export async function InCoreDTFromModel(
    id: string,
    dTName: string,
    ajaxUrl: string,
    actions: any,
    controller: string = "",
    delta: any = undefined,
    refreshName: string | undefined = undefined
): Promise<DataTables.Api | null> {
    const noaction = !actions || actions.length === 0;
    const cfg = await InCoreReadDTConfig(id, dTName, ajaxUrl, controller, noaction);

    if (!cfg) {
        InCoreSwal2(InCoreSwal2Icon.Error, "Unable to load table configuration");
        return null;
    }

    if (delta) {
        Object.keys(delta).forEach((key) => {
            if (key !== "IdField" && key !== "DTName") {
                cfg[key] = delta[key];
            }
        });
    }

    const t = InCoreDTCustom(id, cfg, actions, refreshName);

    if (cfg.filters && cfg.filters.length > 0) {
        InCoreDTRenderFilters(id, cfg, t);
    }

    return t;
}

/**
 * Reads DataTable configuration from the server.
 * @param {string} id - ID of the HTML table.
 * @param {string} dTName - Name of the DataTable on the server model.
 * @param {string} ajaxUrl - URL for the AJAX call to populate the table.
 * @param {string} controller - Absolute path for DataTables in other views.
 * @param {boolean} noaction - Whether to exclude the actions column.
 * @returns {Promise<any>} - DataTable configuration object.
 */
export async function InCoreReadDTConfig(
    id: string,
    dTName: string,
    ajaxUrl: string,
    controller: string,
    noaction: boolean
): Promise<any> {
    return new Promise((resolve, reject) => {
        var actionsupposed = false;
        $.ajax({
            type: "GET",
            url: `${controller}InCoreDTConfig/${dTName}`,
            dataType: "json",
            success: (result) => {
                const head = $(`#${id} thead tr`);
                result.columns.forEach((col: any) => {
                    $(head).append(`<th>${col.title}</th>`);
                });

                formatColumns(result.columns);

                if (result.Actions) {
                    $(head).find("th").last().addClass("dt-nosorting").css("width", "1rem");
                    actionsupposed = true;
                }

                const config = {
                    //dom: new InCoreDTOptions().GetDOM(),
                    ajax: {
                        type: "GET",
                        dataSrc: "",
                        url: ajaxUrl,
                    },
                    columns: result.columns,
                    IdField: result.IdField,
                    actionsGrouped: result.ActionGrouped,
                    order: result.order || [],
                    DTName: dTName,
                    filters: result.filters || []
                };

                if (actionsupposed && noaction) {
                    config.columns.pop();
                }

                resolve(config);
            },
            error: () => {
                InCoreSwal2(InCoreSwal2Icon.Error, "Unable to load table configuration");
                reject(null);
            },
        });
    });
}

/**
 * Manages row actions for DataTables.
 * @param {any} actions - Actions configuration.
 * @param {any} delta - Additional configuration.
 * @returns {Array} - Column definitions for actions.
 */
export function DTManageActions(actions: any, delta: any): any[] {
    const buttonBlockTop = `
        <div class="dt-azioni dropdown">
            <button class="btn dropdown-toggle" type="button" id="btn_{1}_{0}" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="incore-mi-normal">arrow_drop_down_circle</i>
            </button>
            <ul class="dropdown-menu" aria-labelledby="btn_{1}_{0}">
    `;
    const buttonHRefBlock = `<li incore-permission-type="{PERMTYPE}" incore-permission-value="{PERMVALUE}">
                                <a class="dropdown-item {CLASSES}" href="{HREF}" target="{TARGET}">{LABEL}</a>
                             </li>`;
    const buttonClickBlock = `<li incore-permission-type="{PERMTYPE}" incore-permission-value="{PERMVALUE}">
                                    <a class="dropdown-item {CLASSES}" onclick="{CLICK}">{LABEL}</a>
                              </li>`;
    const buttonBlockBottom = `</ul></div>`;

    return [
        {
            targets: -1,
            data: null,
            class: "text-start",
            render: function (data: any, type: any, row: any) {
                let block = buttonBlockTop;
                actions.getActions().forEach((act: any) => {
                    if (act.href) {
                        block += buttonHRefBlock
                            .replace("{HREF}", act.href)
                            .replace("{TARGET}", act.target)
                            .replace("{LABEL}", act.label)
                            .replace("{CLASSES}", act.classes)
                            .replace("{PERMTYPE}", act.permissionType)
                            .replace("{PERMVALUE}", act.permissionValue);
                    } else if (act.click) {
                        block += buttonClickBlock
                            .replace("{CLICK}", act.click)
                            .replace("{LABEL}", act.label)
                            .replace("{CLASSES}", act.classes)
                            .replace("{PERMTYPE}", act.permissionType)
                            .replace("{PERMVALUE}", act.permissionValue);
                    }
                });
                block += buttonBlockBottom;

                const idToken = String(row[delta.IdField] ?? "");
                const nameToken = String(delta.DTName ?? "");
                return block
                    .replace(new RegExp("\\{0\\}", "g"), idToken)
                    .replace(new RegExp("\\{1\\}", "g"), nameToken);
            },
        },
    ];
}

/**
 * Loads DataTable configurations from a JSON file and initializes tables.
 * @param {string} path - Path to the JSON file containing table configurations.
 */
export function loadDataTablesFromJSON(path: string): void {
    $.getJSON(path, (data) => {
        $.each(data, (_key, val) => {
            $.each(val, (_k, v) => {
                InCoreDTCustom(v["ID"], { ajax: v["ajax"], columns: v["columns"] });
            });
        });
    });
}

/**
 * Applies formatting to DataTable columns based on their `format` property.
 * @param {any[]} columns - Array of column definitions.
 */
export function formatColumns(columns: any[]): void {
    const toBool = (v: any): boolean => {
        if (v === true) return true;
        if (v === false || v === null || v === undefined) return false;
        if (typeof v === "string") {
            const s = v.trim().toLowerCase();
            if (s === "true" || s === "1" || s === "yes") return true;
            if (s === "false" || s === "0" || s === "no") return false;
            return false;
        }
        if (typeof v === "number") return v === 1;
        return false;
    };

    columns.forEach((col) => {
        switch (col.format) {
            case "integer":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(data);
                break;

            case "number":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(data);
                break;

            case "percentual":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(data) + '%';
                break;
            case "scientific":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { notation: 'scientific' }).format(data);
                break;

            case "engineering":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { notation: 'engineering' }).format(data);
                break;

            case "currency":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(data);
                break;

            case "dot":
                col.render = (data: any) => {
                    if (!data) return "";
                    let prefix: string = '#';
                    if (data.startsWith(prefix)) {
                        prefix = '';
                    }
                    return `<i class="fa-solid fa-circle" style="color: ${prefix}${data}"></i>`;
                }

            case "textdot":
                col.render = (data: any) => {
                    if (!data) return "";
                    const datas = data.split('|');
                    let prefix = '#';
                    if (datas[0].startsWith(prefix)) {
                        prefix = '';
                    }
                    return `<i class="fa-solid fa-circle" style="color: ${prefix}${datas[0]}"></i>&nbsp;${datas[1]}`;
                }

            case "date":
                col.render = (data: any) => {
                    if (!data) return "";
                    const temp = new Date(data);
                    if (isNaN(temp.getTime())) return "";
                    return temp.toLocaleDateString("it-IT");
                };
                break;

            case "datetimeminutes":
                col.render = (data: any) => {
                    if (!data) return "";
                    const temp = new Date(data);
                    if (isNaN(temp.getTime())) return "";
                    return `${temp.toLocaleDateString("it-IT")} ${temp.toLocaleTimeString("it-IT", {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}`;
                };
                break;

            case "datetimeseconds":
                col.render = (data: any) => {
                    if (!data) return "";
                    const temp = new Date(data);
                    if (isNaN(temp.getTime())) return "";
                    return `${temp.toLocaleDateString("it-IT")} ${temp.toLocaleTimeString("it-IT", {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                    })}`;
                };
                break;

            case "boolean":
                col.render = (data: any) => (data === true ? '<i class="fa-solid fa-check"></i>' : "");
                break;

            case "booleanx":
                col.render = (data: any) =>
                    data === true ? '<i class="fa-solid fa-check"></i>' : '<i class="fa-solid fa-xmark"></i>';
                break;

            default:
                break;
        }
    });
}

/**
 * Class for managing DataTable DOM configurations.
 */
export class InCoreDTOptions {
    length: boolean;
    export: boolean;
    search: boolean;
    info: boolean;
    paging: boolean;
    processing: boolean;
    buttons: boolean;
    colreorder: boolean;
    scroller: boolean;
    searchpanes: boolean;
    searchbuilder: boolean;
    table: boolean;

    constructor(
        Length = true,
        Export = true,
        Search = true,
        Info = true,
        Paging = true,
        Processing = true,
        Buttons = true,
        ColReorder = false,
        Scroller = false,
        SearchPanes = false,
        SearchBuilder = false,
        Table = true
    ) {
        this.length = Length;
        this.export = Export;
        this.search = Search;
        this.info = Info;
        this.paging = Paging;
        this.processing = Processing;
        this.buttons = Buttons;
        this.colreorder = ColReorder;
        this.scroller = Scroller;
        this.searchpanes = SearchPanes;
        this.searchbuilder = SearchBuilder;
        this.table = Table;
    }
}

/**
 * Initializes a DataTable with a custom DOM configuration and optional overrides.
 * @param {string} id - ID of the HTML table.
 * @param {string | undefined} dom - Custom DOM configuration. Defaults to the standard DOM.
 * @param {any} delta - Configuration overrides.
 * @param {string | undefined} refreshName - Optional refresh button method name.
 * @returns {DataTables.Api | null} - DataTable instance or null if already initialized.
 */
export function InCoreDT(
    id: string,
    dom: string | undefined,
    delta: any = undefined,
    refreshName: string | undefined = undefined
): DataTables.Api | null {
    // Ensure the table exists in the DOM
    const tableElement = $(`#${id}`);
    if (!tableElement.length) {
        console.warn(`Table with ID "${id}" not found.`);
        return null;
    }

    // Check if the table is already initialized
    if ($.fn.dataTable.isDataTable(`#${id}`)) {
        console.warn(`Table with ID "${id}" is already initialized as a DataTable.`);
        return tableElement.DataTable(); // Return the existing DataTable instance
    }

    // Prepare the configuration
    const deltaInt = {
        //dom: dom ?? new InCoreDTOptions().GetDOM(),
    };

    console.warn(deltaInt);

    if (delta) {
        Object.assign(deltaInt, delta);
    }

    // Initialize the DataTable
    return InCoreDTCustom(id, deltaInt, undefined, refreshName);
}